import { SettingsUsersUserDto, SettingsUsersUserFullDto } from '../interfaces';
import { generateId } from '../../../../utils';
import {
    Field,
    generateRandomInteger,
    generateRandomFirstName,
    generateRandomLastName,
    generateRandomLogin,
    generateRandomEmail,
    generateRandomISOString,
    generateRandomCountry,
    generateRandomIanaTimeZone,
} from '../../../lib';

export const mockUserFields: Field<SettingsUsersUserDto>[] = [
    {
        fieldName: 'id',
        value: generateId,
    },
    {
        fieldName: 'login',
        value: generateRandomLogin,
    },
    {
        fieldName: 'firstName',
        value: generateRandomFirstName,
    },
    {
        fieldName: 'lastName',
        value: generateRandomLastName,
    },
    {
        fieldName: 'registrationDate',
        value: generateRandomISOString,
    },
    {
        fieldName: 'lastLogonDate',
        value: generateRandomISOString,
    },
];

export const mockUserFullFields: Field<SettingsUsersUserFullDto>[] = [
    {
        fieldName: 'id',
        value: generateId,
    },
    {
        fieldName: 'login',
        value: generateRandomLogin,
    },
    {
        fieldName: 'firstName',
        value: generateRandomFirstName,
    },
    {
        fieldName: 'lastName',
        value: generateRandomLastName,
    },
    {
        fieldName: 'email',
        value: generateRandomEmail,
    },
    {
        fieldName: 'clientGroupId',
        value: generateId,
    },
    {
        fieldName: 'companyId',
        value: generateId,
    },
    {
        fieldName: 'timeZone',
        value: generateRandomIanaTimeZone,
    },
    {
        fieldName: 'campaignId',
        value: generateId,
    },
    {
        fieldName: 'country',
        value: generateRandomCountry,
    },
    {
        fieldName: 'zip',
        value: () => generateRandomInteger(4).toString(),
    },
    {
        fieldName: 'state',
        value: null,
    },
    {
        fieldName: 'county',
        value: null,
    },
    {
        fieldName: 'city',
        value: null,
    },
    {
        fieldName: 'address1',
        value: null,
    },
    {
        fieldName: 'address2',
        value: null,
    },
    {
        fieldName: 'phone',
        value: null,
    },
    {
        fieldName: 'filter',
        value: null,
    },
    {
        fieldName: 'userLocked',
        value: () => !!Math.floor(Math.random() + 1),
    },
];
